import getLang from 'LearningCenterUI/utils/getLang';
import { useMemo } from 'react';
import { getAllCertsByLanguage, getMostPopularCertsInEnglish } from '../features/certificates/certificatesUtils';
import { useAllTracks } from '../features/tracks';
import { useAwards } from '../features/userProgress';
export const useRecommendedCertificates = () => {
  const lang = getLang();
  const {
    allTracks: tracks
  } = useAllTracks();
  const {
    awards
  } = useAwards();
  const numCertificates = useMemo(() => awards && Object.entries(awards).filter(([trackId, award]) => {
    const track = tracks[parseInt(trackId, 10)];
    return track && track.certification && !award.isExpired;
  }).length, [awards, tracks]);
  const mostPopularCertificates = useMemo(() => {
    let result;
    if (lang === 'en') {
      result = getMostPopularCertsInEnglish(tracks, awards);
    } else {
      result = getAllCertsByLanguage(lang, tracks, awards);
    }
    return result;
  }, [awards, lang, tracks]);
  return {
    numCertificates,
    mostPopularCertificates
  };
};